module.exports = __webpack_public_path__ + "img/24110802.81efe9a0.png";